module.exports = __webpack_public_path__ + "static/media/1-en.44771a7.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/audio/1-en.wav
// module id = Lsx4
// module chunks = 1